import { cn } from '@reflex/ui/lib/utils';

export function InfoPanel({ children, className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div className={cn('rounded-lg border border-border bg-muted/30 p-3', className)} {...props}>
      {children}
    </div>
  );
}
